<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <v-autocomplete
                @update:search-input="SearchProveedor"
                @change="(val) => $emit('change', val)"
                v-model="id_proveedor"
                :items="proveedores"
                :item-text="itemText"
                item-value="id"
                :label="label"
                :outlined="outlined"
                :dense="dense"
                :disabled="disabled"
            >
                <template v-if="dynamic" v-slot:item="data">
                    {{ data.item["nombre"] }}
                    <v-spacer></v-spacer>
                    <v-icon
                        @click="openEditDialog(data.item.id)"
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                    <v-icon
                        @click="openDeleteDialog(data.item.id)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </template>
                <template v-slot:append-item>
                    <div v-intersect="endIntersect" />
                </template>
            </v-autocomplete>
        </div>
    </div>
</template>
<script>
import { debounce } from "../../helpers";

export default {
    props: {
        value: {
            type: [Number, String],
            default: null,
        },
        extra: {
            type: Object,
            default: () => {},
        },
        label: {
            type: String,
            default: "Proveedor",
        },
        itemText: {
            type: String,
            default: "nombre",
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
        dynamic: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            creado: null,
            id_proveedor: null,
            proveedor: {},
            dialog: false,
            users: [],
            update: false,
        };
    },
    watch: {
        value(val) {
            this.id_proveedor = val;
        },
        id_proveedor(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        SearchProveedor: debounce(function (val) {
            this.$store.dispatch("searchProveedor", val);
        }, 500),
        mergeProveedor(list, proveedor) {
            if (!proveedor || Object.keys(proveedor).length === 0) {
                return list;
            }

            const hasValidId =
                proveedor.id !== undefined && proveedor.id !== null;
            const index = hasValidId
                ? list.findIndex((item) => item.id === proveedor.id)
                : -1;

            if (index !== -1) {
                const updatedList = list.slice();
                updatedList.splice(index, 1, { ...list[index], ...proveedor });
                return updatedList;
            }

            if (!hasValidId && list.includes(proveedor)) {
                return list;
            }

            return [...list, proveedor];
        },
        endIntersect(entries, observer, isIntersecting) {
            if (isIntersecting) {
                this.$store.dispatch("getProveedoresNext", this);
            }
        },

        openDeleteDialog(id) {
            this.$emit("delete", id);
        },
        openEditDialog(id) {
            this.$emit("edit", id);
        },
    },
    mounted() {
        if (this.$store.getters.getproveedores.length == 0) {
            this.$store.dispatch("getProveedores", this);
        }
        if (this.value != null) {
            this.id_proveedor = this.value;
        }
    },
    computed: {
        proveedores() {
            ///console.log("siva");
            const proveedoresFromStore =
                this.$store.getters.getproveedores || [];
            let proveedoresTemp = proveedoresFromStore.slice();

            if (this.extra?.nombre != null) {
                proveedoresTemp = this.mergeProveedor(
                    proveedoresTemp,
                    this.extra
                );
            }

            if (this.creado) {
                proveedoresTemp = this.mergeProveedor(
                    proveedoresTemp,
                    this.creado
                );
            }

            // console.log(proveedoresTemp);
            return proveedoresTemp;
        },
    },
};
</script>
